import * as React from "react";
const PolishNoteAiSvg = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={24}
      y={24}
      width={24}
      height={24}
      rx={6}
      transform="rotate(180 24 24)"
      fill="#171717"
    />
    <path d="M16 5.072a8 8 0 1 0 0 13.856" stroke="#fff" strokeWidth={2} />
    <path
      d="m22 12 .78.625.5-.625-.5-.625zm-9-1a1 1 0 1 0 0 2zm5 6 .78.625 4-5L22 12l-.78-.625-4 5zm4-5 .78-.625-4-5L18 7l-.78.625 4 5zm0 0v-1h-9v2h9z"
      fill="#fff"
    />
  </svg>
);
export default PolishNoteAiSvg;
